export const ROUTE_PAYCENTER_REQUEST = "ROUTE_PAYCENTER_REQUEST";
export const ROUTE_PAYCENTER_SUCCESS = "ROUTE_PAYCENTER_SUCCESS";
export const ROUTE_PAYCENTER_FAILURE = "ROUTE_PAYCENTER_FAILURE";

export const ROUTING_CONFIG_REQUEST = "ROUTING_CONFIG_REQUEST";
export const ROUTING_CONFIG_SUCCESS = "ROUTING_CONFIG_SUCCESS";
export const ROUTING_CONFIG_FAILURE = "ROUTING_CONFIG_FAILURE";

export const GET_MOBILE_DOMAIN_BRAND_IDENTITY_REQUEST =
  "GET_MOBILE_DOMAIN_BRAND_IDENTITY_REQUEST";
export const GET_MOBILE_DOMAIN_BRAND_IDENTITY_SUCCESS =
  "GET_MOBILE_DOMAIN_BRAND_IDENTITY_SUCCESS";
export const GET_MOBILE_DOMAIN_BRAND_IDENTITY_FAILURE =
  "GET_MOBILE_DOMAIN_BRAND_IDENTITY_FAILURE";

export const LIST_API_TYPES_REQUEST = "LIST_API_TYPES_REQUEST";
export const LIST_API_TYPES_SUCCESS = "LIST_API_TYPES_SUCCESS";
export const LIST_API_TYPES_FAILURE = "LIST_API_TYPES_FAILURE";

export const LIST_API_INTEGRATIONS_REQUEST = "LIST_API_INTEGRATIONS_REQUEST";
export const LIST_API_INTEGRATIONS_SUCCESS = "LIST_API_INTEGRATIONS_SUCCESS";
export const LIST_API_INTEGRATIONS_FAILURE = "LIST_API_INTEGRATIONS_FAILURE";

export const LIST_HIDE_VIEW_REQUEST = "LIST_HIDE_VIEW_REQUEST";
export const LIST_HIDE_VIEW_SUCCESS = "LIST_HIDE_VIEW_SUCCESS";
export const LIST_HIDE_VIEW_FAILURE = "LIST_HIDE_VIEW_FAILURE";
